import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Modal,
  Nav,
  Navbar,
  Row,
  Tab,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  FcBusinessContact,
  FcCalendar,
  FcCellPhone,
  FcDoughnutChart,
  FcViewDetails,
} from "react-icons/fc";
import { HiChatAlt } from "react-icons/hi";
import { MdReviews } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";
import LangChanger from "../component/LangChanger";
import { UseAuth } from "../context/Auth";
import { ProfessionalProvider } from "../context/ProfContext";
import Astro_logo1 from "../images/Astro_logo1.png";
import noimage from "../images/noimage.jpg";
import AudioCallProfessional from "./AudioCallProfessional";
import ConsultantChatHistory from "./Consultant/ConsultantChatHistory";
import ConsultantReview from "./Consultant/ConsultantReview";
import Panchangam from "./Consultant/Panchangam";
import ProfAppointment from "./ProfAppointment";
import ProfDash from "./ProfDash";
import ProfProfile from "./ProfProfile";
import ProfUserMeeting from "./profUserMeeing";

const ProfessionalTabs = () => {
  const token = window.sessionStorage.getItem("token");
  const userId = window.sessionStorage.getItem("userId");
  const AuthName = window.sessionStorage.getItem("authname");
  const lang = window.localStorage.getItem("i18nextLng");
  const { t } = useTranslation();
  const { onLogout } = UseAuth();
  const navigate = useNavigate();

  const [imgUrl, setImgUrl] = useState();
  const [status, setStatus] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState({});
  const [getDetails, setGetDetails] = useState({});
  const [statusList, setStatusList] = useState([]);
  const [userData, setUserData] = useState([]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (statusId) => {
    setShow(true);
    const currentStatus = statusList.find((stat) => stat.id == statusId);
    setSelectedStatus(currentStatus || {});
  };

  const [dataModal, setDataModal] = useState(false);

  const handleDataModalClose = () => setDataModal(false);
  const handleDataModalShow = () => setDataModal(true);

  // Fetch chat data
  useEffect(() => {
    const fetchData = () => {
      vasthuUrl
        .get(`/getInteractionDetailsforConsultant/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setUserData(res.data);
          if (res.data.status === "in-progress" && res.data.astroMessage !== "WC") {
            handleDataModalShow();
          }
          if (res.data.status === "Completed") {
            handleDataModalClose();
          }
          console.log("res.data", res.data);
        })
        .catch((error) => {
          console.log("SERVER ERROR", error);
        });
    };

    fetchData();
    const intervalId = setInterval(fetchData, 15000);
    return () => clearInterval(intervalId);
  }, []);

  // Fetch status list and current user status
  useEffect(() => {
    const fetchStatusList = async () => {
      try {
        const res = await vasthuUrl.get(`info/getprofcallstatus`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStatusList(res.data);
      } catch (error) {
        console.error("Failed to fetch status list", error);
      }
    };

    const fetchUserStatus = async () => {
      try {
        const res = await vasthuUrl.get(`info/getProStatus/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setGetDetails(res.data[0]);
      } catch (error) {
        console.error("Failed to fetch user status", error);
      }
    };

    fetchStatusList();
    fetchUserStatus();
  }, [token, userId]);

  const updateDetail = async () => {
    try {
      await vasthuUrl.post(
        `info/professional/updateStatusForProfessional/${userId}`,
        { profstatus: status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setGetDetails(statusList.find((stat) => stat.id == status));
    } catch (error) {
      console.error("Failed to update status", error);
    }
  };

  const updateOnLogout = () => {
    onLogout();
  };

  useEffect(() => {
    const fetchProfileImage = async () => {
      try {
        const res = await vasthuUrl.get(`getuserprofiledetail/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setImgUrl(res.data.profileUrl);
      } catch (error) {
        console.error("Failed to fetch profile image", error);
      }
    };
    fetchProfileImage();
  }, [token, userId]);

  return (
    <ProfessionalProvider>
      {/* Tab Container */}
      <Tab.Container
        id="left-tabs-example"
        defaultActiveKey="Professionaldash"
        mountOnEnter={false}
        unmountOnExit={false}
      >
        <Row>
          {/* Left Nav */}
          <Col className="adminLeft" sm={12} md={3}>
            <Card
              className="text-center border-warning m-1"
              style={{ width: "100%" }}
            >
              <Card.Body className="all_border">
                {imgUrl ? (
                  <Image
                    fluid
                    thumbnail
                    roundedCircle
                    style={{ width: 100, height: 100, objectFit: "cover" }}
                    src={imgUrl}
                    alt="profile"
                  />
                ) : (
                  <Image
                    fluid
                    thumbnail
                    roundedCircle
                    style={{ width: 100, height: 100, objectFit: "cover" }}
                    src={noimage}
                  />
                )}
                <Card.Header className="all_border">
                  <Card.Title>{t("TXT.CON.LO")}</Card.Title>
                </Card.Header>
              </Card.Body>

              <Nav
                variant="pills"
                bg="warning"
                className="flex-column"
                style={{ cursor: "pointer" }}
              >
                <Nav.Item>
                  <Nav.Link eventKey="Professionaldash">
                    {t("PR.LNK.DS")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="ProfessionalAppoint">
                    {t("PR.LNK.APMNT")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="ProfessionalUserMeeting">
                    {t("PR.APMNT.MTNGTAB")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Professionalprofile">
                    {t("PR.LNK.AC")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="audiocallprofessional">
                    {t("CON.DAS.AUD.CAL")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="consultantChatHistory">
                    {t("USR.CHAT.HIS.HEAD.UP")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="consultantreview">
                    {t("CON.DAS.REVI")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="panchangam">
                    {t("BRTH.CHART.UP.CASE")}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card>
          </Col>

          {/* Right Content */}
          <Col sm={12} md={9}>
            <Navbar expand={"md"} className="professionalHeader all_background">
              <Container fluid>
                <Navbar.Brand href="#" className="prof_user">
                  <div>{t("CM_PUB_LOGO_TITLE")}</div>
                  {AuthName && (
                    <h3 style={{ marginRight: "1rem" }}>{AuthName}</h3>
                  )}
                </Navbar.Brand>
                <Nav>
                  <div style={{ display: "ruby" }}>
                    <div className="px-1 my-1">
                      <Form>
                        <Form.Select
                          style={{ width: "120px" }}
                          value={status || getDetails.id}
                          onChange={(e) => {
                            setStatus(e.target.value);
                            handleShow(e.target.value);
                          }}
                        >
                          {statusList
                            .filter((i) => i.id == getDetails.id)
                            .map((i) => (
                              <option key={i.id} value={i.id}>
                                {lang === "en"
                                  ? i.status
                                  : lang === "ta"
                                    ? i.status_ta
                                    : i.status_hi}
                              </option>
                            ))}
                          {statusList
                            .filter((i) => i.id !== getDetails.id)
                            .map((i) => (
                              <option key={i.id} value={i.id}>
                                {lang === "en"
                                  ? i.status
                                  : lang === "ta"
                                    ? i.status_ta
                                    : i.status_hi}
                              </option>
                            ))}
                        </Form.Select>
                      </Form>
                    </div>
                    <div className="mt-2">
                      <LangChanger />
                    </div>
                    <div className="px-1 my-1">
                      <Button
                        variant="light"
                        size="md"
                        style={{ fontWeight: "bold" }}
                        onClick={updateOnLogout}
                      >
                        {t("PR.LOUT")}
                      </Button>
                    </div>
                  </div>
                </Nav>
              </Container>
            </Navbar>
            <Row>
              <Col className="adminTabMobile">
                <Card className="m-1">
                  <Nav
                    variant="pills"
                    className="justify-content-center text-center py-1"
                  >
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="Professionaldash"
                        href="#"
                      >
                        {t("PR.LNK.DS")}
                        <br />
                        <FcDoughnutChart size={30} />
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="ProfessionalAppoint"
                        href="#"
                      >
                        {t("PR.LNK.APMNT")}
                        <br />
                        <FcCalendar size={30} />
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="ProfessionalUserMeeting"
                        href="#"
                      >
                        {t("PR.APMNT.MTNGTAB")}
                        <br />
                        <FcViewDetails size={30} />
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="Professionalprofile"
                        href="#"
                      >
                        {t("PR.LNK.AC")}
                        <br />
                        <FcBusinessContact size={30} />
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="audiocallprofessional"
                        href="#"
                      >
                        {t("CON.DAS.AUD.CAL")}
                        <br />
                        <FcCellPhone size={30} />
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="consultantChatHistory"
                        href="#"
                      >
                        {t("USR.CHAT.HIS.HEAD.UP")}
                        <br />
                        <HiChatAlt size={30} />
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="consultantreview"
                        href="#"
                      >
                        {t("CON.DAS.REVI")}
                        <br />
                        <MdReviews size={30} />
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="panchangam"
                        href="#"
                      >
                        {t("BRTH.CHART.UP.CASE")}
                        <br />
                        <Image
                          src={Astro_logo1}
                          alt="Logo"
                          style={{
                            height: "40px",
                            width: "40px",
                            objectFit: "contain",
                          }}
                        />
                      </Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <Nav.Link
                        style={{ fontSize: 10 }}
                        eventKey="startlivecall"
                        href="#"
                      >
                        START LIVE
                        <br />
                        <TbLivePhoto size={30} />
                      </Nav.Link>
                    </Nav.Item> */}
                  </Nav>
                </Card>
              </Col>
            </Row>
            <Tab.Content className="adminTab">
              <Tab.Pane eventKey="Professionaldash">
                <ProfDash />
              </Tab.Pane>
              <Tab.Pane eventKey="ProfessionalAppoint">
                <ProfAppointment />
              </Tab.Pane>
              <Tab.Pane eventKey="Professionalprofile">
                <ProfProfile />
              </Tab.Pane>
              <Tab.Pane eventKey="ProfessionalUserMeeting">
                <ProfUserMeeting />
              </Tab.Pane>
              <Tab.Pane eventKey="audiocallprofessional">
                <AudioCallProfessional />
              </Tab.Pane>
              <Tab.Pane eventKey="consultantChatHistory">
                <ConsultantChatHistory />
              </Tab.Pane>
              <Tab.Pane eventKey="consultantreview">
                <ConsultantReview />
              </Tab.Pane>
              <Tab.Pane eventKey="panchangam">
                <Panchangam />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>

      {/* Status Modal */}
      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header className="modal-header all_background" closeButton>
          <Modal.Title>{t("CON.MDL.STS.HEAD")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {statusList
              .filter((i) => i.id == getDetails.id)
              .map((i) => (
                <p key={i.id} value={i.id}>
                  {t("CON.MDL.CURNT.STS")}:
                  {lang === "en"
                    ? i.status
                    : lang === "ta"
                      ? i.status_ta
                      : i.status_hi}
                </p>
              ))}
            <p>
              {t("CON.MDL.SELCT.STS")}:{" "}
              {lang === "en"
                ? selectedStatus.status
                : lang === "ta"
                  ? selectedStatus.status_ta
                  : selectedStatus.status_hi}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="all_btn"
            onClick={() => {
              setStatus(selectedStatus.id);
              updateDetail();
              handleClose();
            }}
          >
            {t("CON.MDL.CNF.BTN")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Chat & call Alert Modal */}
      <Modal
        show={dataModal}
        onHide={handleDataModalClose}
        animation={false}
        size="lg"
      >
        <Modal.Header className="modal-header all_background" closeButton>
          <Modal.Title className="w-100 text-center">
            {t("USR.CHAT.ALT.MDL.HEAD")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {userData ? (
            <>
              <Row>
                {userData.astroUserDetails ? (
                  <Col
                    style={{
                      border: "1px solid #ffb33c",
                      backgroundColor: "antiquewhite",
                      padding: "20px",
                      borderBottomRightRadius: "5px",
                    }}
                    xs={12}
                    sm={12}
                    md={6}
                    className="mx-auto text-center"
                  >
                    <Card.Header>
                      <h4 style={{ color: "#b11b1b" }}>PERSONAL DETAILS</h4>
                    </Card.Header>
                    <Card.Text>
                      Name: {userData.astroUserDetails.userName}
                    </Card.Text>
                    <Card.Text>
                      Date Of Birth: {userData.astroUserDetails.birthDate}
                    </Card.Text>
                    <Card.Text>
                      Birth Time:
                      {/* {userData.astroUserDetails.birthTime} */}
                      {dayjs(
                        userData.astroUserDetails.birthTime,
                        "HH:mm:ss"
                      ).format("hh:mm A")}
                    </Card.Text>
                    <Card.Text>
                      Birth Place: {userData.astroUserDetails.userBirthstate}
                    </Card.Text>
                  </Col>
                ) : (
                  <div className="d-flex flex-wrap justify-content-center g-3">
                    {userData.astroMatchingDetails ? (
                      <>
                        <Col
                          style={{
                            border: "1px solid #ffb33c",
                            backgroundColor: "antiquewhite",
                            padding: "25px",
                          }}
                          xs={12}
                          sm={12}
                          md={6}
                        >
                          <Card.Header className="text-center">
                            <h4 style={{ color: "#b11b1b" }}>MALE</h4>
                          </Card.Header>
                          <Card.Text>
                            Name: {userData.astroMatchingDetails.maleUserName}
                          </Card.Text>
                          <Card.Text>
                            Date Of Birth:{" "}
                            {userData.astroMatchingDetails.maleBirthDate}
                          </Card.Text>
                          <Card.Text>
                            Birth Time:{" "}
                            {/* {userData.astroMatchingDetails.maleBirthTime} */}
                            {dayjs(
                              userData.astroMatchingDetails.maleBirthTime,
                              "HH:mm:ss"
                            ).format("hh:mm A")}
                          </Card.Text>
                          <Card.Text>
                            Birth Place:{" "}
                            {userData.astroMatchingDetails.maleBirthPlace}
                          </Card.Text>
                        </Col>
                        <Col
                          style={{
                            border: "1px solid #ffb33c",
                            backgroundColor: "antiquewhite",
                            padding: "25px",
                          }}
                          xs={12}
                          sm={12}
                          md={6}
                        >
                          <Card.Header className="text-center">
                            <h4 style={{ color: "#b11b1b" }}>FEMALE</h4>
                          </Card.Header>
                          <Card.Text>
                            Name: {userData.astroMatchingDetails.femaleUserName}
                          </Card.Text>
                          <Card.Text>
                            Date Of Birth:{" "}
                            {userData.astroMatchingDetails.femaleBirthDate}
                          </Card.Text>
                          <Card.Text>
                            Birth Time:{" "}
                            {/* {userData.astroMatchingDetails.femaleBirthTime} */}
                            {dayjs(
                              userData.astroMatchingDetails.femaleBirthTime,
                              "HH:mm:ss"
                            ).format("hh:mm A")}
                          </Card.Text>
                          <Card.Text>
                            Birth Place:{" "}
                            {userData.astroMatchingDetails.femaleBirthPlace}
                          </Card.Text>
                        </Col>
                      </>
                    ) : (
                      "No Data Available"
                    )}
                  </div>
                )}
              </Row>

              {/* <Row className="mt-3 ">
                <center>
                  <Col xs={12} sm={12} md={6}>
                    <Card.Text>
                      <h4>
                        {t("USR.CHAT.CUSTOMER")}: {userData.customerName}
                      </h4>
                    </Card.Text>
                    <Card.Text>
                      {t("USR.METNG.CDE")}: {userData.meetingCode}
                    </Card.Text>
                    <Card.Text>
                      {t("TXT.STS.LO")}: {userData.status}
                    </Card.Text>
                    <Card.Text>
                      {t("USR.INTI.TIME")}: {userData.chatStartTime}
                    </Card.Text>
                    <Card.Text>
                      {t("USR.PROPO.DUR")}: {userData.proposedChatDuration}
                    </Card.Text>
                  </Col>
                </center>
              </Row> */}
            </>
          ) : (
            <Card.Text>{t("USR.NO.DATA")}</Card.Text>
          )}
        </Modal.Body>
        <Modal.Footer className="all_border">
          <Button
            className="all_btn"
            onClick={
              () => {
                if (userData?.type == "chat") {
                  navigate("/chatscreen");
                } else {
                  navigate("/datacall");
                }
              }
              // navigate("/chatscreen", {
              //   state: { userData },
              // })
            }
          >
            {/* {t("USR.CNF.CHAT.BTN")} */}
            {t("USR.VSH.HFTAB.MDL.CNF.BTN.CNF")}
          </Button>
        </Modal.Footer>
      </Modal>
    </ProfessionalProvider>
  );
};

export default ProfessionalTabs;
